import { AfterContentInit, AfterViewInit, Component, inject, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule, AsyncPipe } from '@angular/common';
import { ContainerComponent } from '@coreui/angular';
import { Observable, of, Subscription } from 'rxjs';
import { DataQueryRulesEditorComponent, ToastService } from '@optima-stride-ai/optima-components';
import { FilterExpressions, IFactAndValue, IRuleValidationResult, LogicalOperators, NodeKind } from '@optima-stride-ai/core';
import { GroupBys ,MoreSection, Selections,AdvancedMathService} from '@optima-stride-ai/core';


@Component({
    selector: 'app-form-biz-rule',
  imports: [CommonModule, AsyncPipe, ContainerComponent, DataQueryRulesEditorComponent],
    templateUrl: './form-biz-rule.component.html',
    styleUrl: './form-biz-rule.component.sass'
})
export class FormBizRuleComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
  @Input() model: { in: any, out: any } = { in: null, out: null };

  mathService = inject(AdvancedMathService);
  toastService = inject(ToastService);

  public selections: Observable<Selections> = of(new Selections([],[],this.mathService, false,""));
  public preDefinedReferences: Observable<IFactAndValue[]> = of([]);
  public groupBys: Observable<GroupBys> = of(new GroupBys([]));
  public filterExpressions: Observable<FilterExpressions> = of(this.getDefaultFilterExpressions());
  public more: Observable<MoreSection> = of(new MoreSection(0));
  public selectedStatusFieldAlias: string | null = null;
  public isProgressKpi: boolean = false;
  public viewOnly: boolean = false;

  private selectionInstance!: Selections;
  private preDefinedReferencesInstance: IFactAndValue[] = []
  private groupBysInstance!: GroupBys
  private filterExpressionInstance!: FilterExpressions;
  private moreSelectionInstance!: MoreSection;

  public get data() {
    return {
      selections: this.selectionInstance, preDefinedReferences: this.preDefinedReferencesInstance, groupBys: this.groupBysInstance, filterExpressions: this.filterExpressionInstance, more: this.moreSelectionInstance, selectedStatusFieldAlias: this.selectedStatusFieldAlias, viewOnly: this.viewOnly
    }
  };
  selectSubscription!: Subscription;
  preDefinedSubscription!: Subscription;
  groupBySubscription!: Subscription;
  filterExpressionSubscription!: Subscription;
  moreSubscription!: Subscription;

  constructor() {
    this.initializeSubscriptions();
  }

  private initializeSubscriptions() {
    this.selectSubscription = this.selections.subscribe((selections) => {
    //  console.log("Selections updated - ", selections)
      this.selectionInstance = selections
    });
    this.preDefinedSubscription = this.preDefinedReferences.subscribe((preDefinedReferences) => this.preDefinedReferencesInstance = preDefinedReferences);
    this.groupBySubscription = this.groupBys.subscribe((groupBys) => this.groupBysInstance = groupBys);
    this.filterExpressionSubscription = this.filterExpressions.subscribe((filterExpressions) => this.filterExpressionInstance = filterExpressions);
    this.moreSubscription = this.more.subscribe((more) => this.moreSelectionInstance = more);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model'] && this.model && this.model.in) {
      this.viewOnly = this.model.in.viewOnly || false;
      // Update observables with new data
      this.selections = of(this.model.in.selections || new Selections([],[],this.mathService, false,""));
      this.preDefinedReferences = of(this.model.in.preDefinedReferences || []);
      this.groupBys = of(this.model.in.groupBys || new GroupBys([]));
      this.filterExpressions = of(this.model.in.filterExpressions || this.getDefaultFilterExpressions());
      this.more = of(this.model.in.more || new MoreSection(0));
      this.selectedStatusFieldAlias = this.model.in.selectedStatusFieldAlias || null;
      this.isProgressKpi = this.model.in.isProgressKpi || false;
      // Re-subscribe with updated observables
   //   this.unsubscribeAll();
    //  this.initializeSubscriptions();
   // console.log(this.more)
    }
  }

  ngOnInit(): void {
    // Initialize with model data if available
    if (this.model && this.model.in) {
      this.selections = of(this.model.in.selections || new Selections([],[],this.mathService, false,""));
      this.preDefinedReferences = of(this.model.in.preDefinedReferences || []);
      this.groupBys = of(this.model.in.groupBys || new GroupBys([]));
      this.filterExpressions = of(this.model.in.filterExpressions || this.getDefaultFilterExpressions());
      this.more = of(this.model.in.more || new MoreSection(0));
      this.selectedStatusFieldAlias = this.model.in.selectedStatusFieldAlias || null;
      this.initializeSubscriptions();
    }
  }

  ngAfterViewInit() {
   // console.log("Form Biz Rule - ngAfterViewInit called", this.model.in)
  }

  ngAfterContentInit(): void {
  }

  private _validationResultSelections: IRuleValidationResult = { hasError: false, errorMessage: "" };
  onSelectionsValidationCheck(result:{hasError: boolean, errorMessage: string}) {
  //   console.log("Validation result - ", result)
    this._validationResultSelections = result;
  } 

  private _validationResultGroupBys: IRuleValidationResult = { hasError: false, errorMessage: "" };
  onGroupBysValidationCheck(result:{hasError: boolean, errorMessage: string}) {
    // console.log("Validation result - ", result)
    this._validationResultGroupBys = result;
  }  

  private _validationResultFilterExpressions: IRuleValidationResult = { hasError: false, errorMessage: "" };
  onFilterExpressionsValidationCheck(result:{hasError: boolean, errorMessage: string}) {
    this._validationResultFilterExpressions = result;
  }

  // Handle data changes from child component
  onSelectionsChange(selections: Selections | null) {
  //  console.log('Selections changed from editor:', selections);
    this.selectionInstance = selections || new Selections([],[],this.mathService, false,"");
  }

  onGroupBysChange(groupBys: GroupBys | null) {
   // console.log('GroupBys changed from editor:', groupBys);
    this.groupBysInstance = groupBys || new GroupBys([]);
  }

  onFilterExpressionsChange(filterExpressions: FilterExpressions | null) {
    //console.log('FilterExpressions changed from editor:', filterExpressions);
    this.filterExpressionInstance = filterExpressions || this.getDefaultFilterExpressions();
  }

  onMoreChange(more: any) {
   // console.log('More section changed from editor:', more);
    this.moreSelectionInstance = more || new MoreSection(0);
    // Handle more section changes if needed
  }

  validate(): boolean {
    if(this._validationResultSelections.hasError || this._validationResultGroupBys.hasError || this._validationResultFilterExpressions.hasError) {
      this.toastService.toast(`${this._validationResultSelections.errorMessage} ${this._validationResultGroupBys.errorMessage} ${this._validationResultFilterExpressions.errorMessage}`);    
    } 
    return !this._validationResultSelections.hasError && !this._validationResultGroupBys.hasError && !this._validationResultFilterExpressions.hasError;

  };

  private unsubscribeAll(): void {
    if (this.selectSubscription) {
      this.selectSubscription.unsubscribe();
    }
    if (this.preDefinedSubscription) {
      this.preDefinedSubscription.unsubscribe();
    }
    if (this.groupBySubscription) {
      this.groupBySubscription.unsubscribe();
    }
    if (this.filterExpressionSubscription) {
      this.filterExpressionSubscription.unsubscribe();
    }
    if (this.moreSubscription) {
      this.moreSubscription.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  private getDefaultFilterExpressions(): FilterExpressions {
    return new FilterExpressions({
      kind: NodeKind.condition,
      condition: [],
      logicalOperator: LogicalOperators.And,
    }, this.mathService, false, "");
  }

    onStatusFieldAliasChanged(statusFieldAlias: string | null) {
    this.selectedStatusFieldAlias = statusFieldAlias;
  }

}
